import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { LogOut, Shield, ClipboardList, Trophy } from "lucide-react";

export default function TopNav() {
  const { user, logout } = useAuth();
  const location = useLocation();
  if (!user) return null;
  const isAdmin = user.role === "admin";

  return (
    <header className="bg-white border-b border-neutral-200 sticky top-0 z-30" data-testid="topnav">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-black text-white flex items-center justify-center font-heading font-black">M</div>
          <div className="font-heading font-black uppercase tracking-tight text-lg">Midtnorsk Hockeyliga</div>
        </div>

        <nav className="hidden md:flex items-center gap-1">
          <Link
            data-testid="nav-dashboard"
            to="/dashboard"
            className={`px-4 h-10 inline-flex items-center font-heading uppercase tracking-widest text-sm border ${location.pathname === "/dashboard" ? "bg-black text-white border-black" : "border-transparent hover:border-neutral-200"}`}
          >
            <ClipboardList className="w-4 h-4 mr-2" />Lagleder
          </Link>
          {isAdmin && (
            <Link
              data-testid="nav-admin"
              to="/admin"
              className={`px-4 h-10 inline-flex items-center font-heading uppercase tracking-widest text-sm border ${location.pathname === "/admin" ? "bg-black text-white border-black" : "border-transparent hover:border-neutral-200"}`}
            >
              <Shield className="w-4 h-4 mr-2" />Admin
            </Link>
          )}
          <Link
            data-testid="nav-standings"
            to="/standings"
            className={`px-4 h-10 inline-flex items-center font-heading uppercase tracking-widest text-sm border ${location.pathname === "/standings" ? "bg-black text-white border-black" : "border-transparent hover:border-neutral-200"}`}
          >
            <Trophy className="w-4 h-4 mr-2" />Tabell
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          <div className="hidden sm:flex items-center gap-2">
            {user.picture && <img src={user.picture} alt="" className="w-8 h-8 rounded-full" />}
            <div className="text-sm">
              <div className="font-semibold leading-tight">{user.name}</div>
              <div className="text-xs uppercase tracking-widest text-neutral-500">{user.role}</div>
            </div>
          </div>
          <Button data-testid="logout-btn" variant="ghost" size="sm" onClick={logout} className="rounded-sm">
            <LogOut className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </header>
  );
}
